import { Button } from '@wartek-id/button-v1'
import { Sheet, SheetContent, SheetOverlay } from '@wartek-id/sheet'
import { Text } from '@wartek-id/text'

import { useMediaQueryHelper } from '../hooks/useMediaQueryHelper'
import DownloadDecreeBlock from './DownloadDecreeBlock'

import type { TUjikomStateOption } from 'types/content-platform'
interface IPassedDecisionDialogProps
  extends React.HTMLAttributes<HTMLDialogElement> {
  isOpen: boolean
  state: TUjikomStateOption | string
  handleClose?: () => void
}

const PassedDecisionDialog = ({
  isOpen,
  state,
  handleClose,
}: IPassedDecisionDialogProps) => {
  const { isDesktop } = useMediaQueryHelper()
  return (
    <Sheet isOpen={isOpen} onClose={handleClose} position="bottom">
      <SheetOverlay />
      <SheetContent className="px-4 pt-5 pb-4 max-w-2xl m-auto">
        <Text variant="heading-md" className="mb-2">
          Selengkapnya tentang kelulusan Uji Kompetensi
        </Text>
        {(state === 'FORM_CERTIFICATE_GENERATED' ||
          state === 'FORM_COMPLETED') && (
          <>
            <Text variant="body" color="subdued" className="mb-6">
              Berdasarkan Surat Pengumuman Nomor 3437/B/HK.04.01/2023, Anda
              dinyatakan lulus serta memenuhi syarat untuk diangkat ke dalam JF
              Guru Ahli Muda. Kami ucapkan selamat atas lulusnya!
              <br />
              <br />
              Mohon cek Surat Keputusan Kelulusan dan Surat Rekomendasi, ya.
            </Text>
          </>
        )}

        {state === 'FORM_CONDITIONAL_QUALIFIED' && (
          <>
            <Text variant="body" color="subdued" className="mb-6">
              Berdasarkan Surat Pengumuman Nomor 3437/B/HK.04.01/2023, Anda
              dinyatakan perlu klarifikasi data melalui akun SIMPKB Anda dengan
              mengunggah dokumen:
              <ol className="list-decimal ml-5">
                <li>
                  Persetujuan teknis kenaikan pangkat/golongan dari Penata Muda
                  Tingkat I golongan ruang III/b ke Penata golongan ruang III/c
                  yang ditetapkan oleh Kepala Kantor Regional BKN, atau
                </li>
                <li>
                  Surat Keputusan Pengangkatan Penata Golongan Ruang III/c
                </li>
              </ol>
              <br />
              Jika lolos klarifikasi, Anda bisa mengakses sertifikat dan akan
              diangkat ke dalam JF Guru Ahli Muda. Jika tidak lolos klarifikasi,
              pengangkatan Anda ke dalam JF Guru akan diberikan di Jenjang Guru
              Ahli Pertama.
              <br />
              <br />
              Cek juga Surat Pengumuman dan Surat Rekomendasi, ya.{' '}
            </Text>
          </>
        )}

        {state === 'FORM_NOT_QUALIFIED' && (
          <>
            <Text variant="body" color="subdued" className="mb-6">
              Berdasarkan Surat Pengumuman Nomor 3437/B/HK.04.01/2023, Anda
              dinyatakan belum bisa diangkat ke dalam JF Guru Ahli Muda.
              <br />
              <br />
              Terima kasih atas kesungguhan Anda dan tetap semangat mendukung
              transformasi pendidikan di Indonesia demi peningkatan kualitas
              generasi muda bangsa.
              <br />
              <br />
              Mohon cek Surat Pengumuman dan Surat Rekomendasi, ya.
            </Text>
          </>
        )}

        <div className={'p-1 m-[-0.25rem]'}>
          <DownloadDecreeBlock className="mb-6" />
          <Button
            color="white"
            className="float-right"
            size="lg"
            fullWidth={!isDesktop}
            onClick={() => {
              handleClose?.()
            }}
          >
            Saya mengerti
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  )
}

export default PassedDecisionDialog
